<template>
  <!-- 遊客中心人次 -->
  <div class="col">
    <div class="card card-clean h-100">
      <div class="card-header bg-white border-0 fw-bold text-indigo h5">
        遊客中心性別比例
      </div>
      <div class="card-body p-2">
        <div class="d-flex justify-content-end">
          <button  class="btn btn-dia " style="" @click="showModal()" v-if="!isShortView">
            <i class="fas fa-search-plus"></i>
          </button>
        </div>
        <div style="margin: auto; max-width: 450px" class="mb-3">
          <apexchart
          
          :options="chartOptions"
          :series="chartSeries"
          ref="chart"
          ></apexchart>
        </div>
        <dialog-modal  id="modalPop" ref="objectDetectionDetail" :showUpdateButton="false" :customUpdateButton="false" :modalSize="'xl'"
          :isImage="false" :isMarginAuto="false" :modalTitle="'遊客中心性別比例'" :closeButton="false" >
          <div class="object-detection-detail w-75 m-auto" >
              <apexchart
                id="chartPop"
                :options="chartOptions"
                :series="chartSeries"
              ></apexchart>
          </div>
        </dialog-modal>
        <div class="chart-description chart-description-btm">
          當日遊客中心遊客的性別比例（屬性攝影機）。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import DialogModal from "../../components/DialogModal.vue";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";
import { mapState, mapGetters } from "vuex";
const zh_tw = require("../../utils/apexchartObject/apexLocales/zh-tw.json");

export default {
  components: {
    apexchart: VueApexCharts,DialogModal
  },
  props: {
    selectedScenicAreaId: {
      type: Number,
    },
  },

  data() {
    return {
      dataInterval: null,
      peopleAttributeListData: [],
      viewPort: window.innerWidth,
      isShortView:false,
      //  測試非空值時間資料 (上機前須更改)
      // startTime:moment().subtract(25, 'hours'),
      // endTime: moment().subtract(1, 'hours'),

      startTime:  moment().startOf("day"),
      endTime: moment().endOf("day"), //取得當日最早時間與最晚時間
      // startTime: "2022-12-02T00:00:00",
      // endTime: "2022-12-02T23:55:55",
      //VueApexCharts Setting
      chartSeries: [],

      chartOptions: {
        chart: {
          type: "pie",
          // height: 300,
          // zoom: {
          //   type: "x",
          //   enabled: true,
          //   autoScaleYaxis: true,
          // },
          defaultLocale: "zh-tw",
          locales: [zh_tw],
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
            export: {
              svg: { filename: undefined },
              png: { filename: undefined },
              csv: { filename: undefined },
            },
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
          },
        },
        states: {
          hover: {
            filter: {
            type: 'none',
            }
          },
          active: {
            allowMultipleDataPointsSelection: true,
            filter: {
              type: "none",
              value: 0,
            },
          },
        },
        dataLabels: {
          enabled: true,
        },
        // stroke: {
        //   curve: "straight",
        //   width: 3,
        // },
        // xaxis: {
        //   type: "datetime",
        //   labels: {
        //     datetimeUTC: false,
        //     // format:'HH',day: 'MM/dd',
        //     datetimeFormatter: {
        //       day: "MM/dd",
        //       hour: "HH",
        //     },
        //   },
        //   categories: [],
        // },
        responsive: [
            {
                breakpoint:1280,
                options: {
                  chart: {
                    width: "100%",
                  },
                  legend: {
                    position: "left",
                    width:120,
                   
                  }
                }
              },
            {
                breakpoint: 380,
                options: {
                  chart: {
                    width: "100%",
                  },
                  legend: {
                    position: "bottom",
                     width:"100%"
                
                  }
                }
              }
        ],
        tooltip:{ enabled: false},
        colors: CONST.APEXCHART_COLOR.LINE_CHART_RANGE_FIVE,
        legend: {
          // width: 120,
          position:"left"
        },
     
      },
    };
  },
  methods: {
    showModal(){
      this.$refs.objectDetectionDetail.openModal();
    },
    //取得每日遊客中心每小時性別人流量
    async getPeopleAttributeListPerDay() {
      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
        scenicAreaId: this.selectedScenicAreaId,
      };

      await this.$store.dispatch(
        "peopleAttribute/getPeopleAttributeListPerDay",
        condition
      );
      this.peopleAttributeListData =
        this.$store.getters["peopleAttribute/getSearchGenderPerDay"];
      // const a = this.peopleAttributeListData.filter((item) => {
      //   return item.scenicAreaName !== null;
      // });
    },

    //處理資料圖表使用
    initGenderDataPerHour() {
      // const genderTypes = Object.values(CONST.GENDER); //['男性', '女性']
      this.chartOptions.labels = Object.values(CONST.GENDER); //['男性', '女性']
      if (
        this.peopleAttributeListData[0].manCount === 0 &&
        this.peopleAttributeListData[0].womanCount === 0 
      ) {
        this.chartSeries = [20, 20];
        this.chartOptions.dataLabels.formatter = function (val, opts) {
          return "0";
        };

        this.$refs.chart.updateOptions(this.chartOptions);
      } else {
        const a = [];
        this.peopleAttributeListData.forEach((item) => {
          a.push([item.manCount, item.womanCount]);
        });
        this.chartSeries  = a[0];

        this.chartOptions.dataLabels.formatter = function (val, opts) {
          return Math.round(Number(val)) + "%";
        };
      
        this.$refs.chart.updateOptions(this.chartOptions);
      }

      this.chartOptions.chart.toolbar.export.svg.filename = `${Utils.getSingleScenicAreaNamebyId(
        this.selectedScenicAreaId
      )}_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`;
      this.chartOptions.chart.toolbar.export.csv.filename = `${Utils.getSingleScenicAreaNamebyId(
        this.selectedScenicAreaId
      )}_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`;
      this.chartOptions.chart.toolbar.export.png.filename = `${Utils.getSingleScenicAreaNamebyId(
        this.selectedScenicAreaId
      )}_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`;
      this.chartOptions = { ...this.chartOptions };
    },
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
  },

  watch: {
    selectedScenicAreaId: {
      async handler(newVal) {
        if (newVal === null) {
          return;
        }
        await this.getPeopleAttributeListPerDay();
        this.initGenderDataPerHour();
      },
      immediate:true
    },
    viewPort:{
      handler(newVal){
        if(newVal < 600){
        this.isShortView = true;
      }else{
        this.isShortView = false;
      }},
      immediate: true
    },
  },

  async mounted() {
    this.$_resizeEventHandler = () => {
      this.viewPort = window.innerWidth;
    };
    window.addEventListener('resize', this.$_resizeEventHandler);
    this.dataInterval = setInterval(async () => {
      await  this.getPeopleAttributeListPerDay();
      this.initGenderDataPerHour();
    }, CONST.REFRESH_DAT_TIMER_MIN);
  },

  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval);
    this.dataInterval = null;
  },
};
</script>

<style  lang="scss" scoped>

// .apexcharts-datalabels{
//   opacity: 1 !important;
// }
</style>